import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  CircularProgress,
  Button
} from '@mui/material';
import ExploreIcon from '@mui/icons-material/Explore';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { huntService } from '../services/huntService';

const Dashboard: React.FC = () => {
  const [stats, setStats] = useState({
    totalHunts: 0,
    activeHunts: 0,
    loading: true,
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const hunts = await huntService.getAllHunts({ limit: 1000 });
      setStats({
        totalHunts: hunts.length,
        activeHunts: hunts.filter(h => h.status === 'active').length,
        loading: false,
      });
    } catch (error) {
      console.error('Error loading stats:', error);
      setStats(prev => ({ ...prev, loading: false }));
    }
  };

  const statCards = [
    {
      title: 'Total Hunts',
      value: stats.totalHunts,
      icon: <ExploreIcon sx={{ fontSize: 40 }} />,
      color: '#2E7D32',
    },
    {
      title: 'Active Hunts',
      value: stats.activeHunts,
      icon: <TrendingUpIcon sx={{ fontSize: 40 }} />,
      color: '#FF6F00',
    },
  ];

  if (stats.loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      <Grid container spacing={3} sx={{ mt: 2 }}>
        {statCards.map((stat) => (
          <Grid item xs={12} sm={6} md={3} key={stat.title}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Box>
                    <Typography color="textSecondary" variant="body2">
                      {stat.title}
                    </Typography>
                    <Typography variant="h4" sx={{ mt: 1 }}>
                      {stat.value}
                    </Typography>
                  </Box>
                  <Box sx={{ color: stat.color }}>
                    {stat.icon}
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Card sx={{ mt: 4 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Welcome to Foraging Foodie Admin Panel
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Manage hunts, users, and content for the Foraging Foodie app.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Dashboard;
